import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { approveUser, rejectUser, removeUser } from '~/actions/camps'

import { Icon } from '~/components'


class Users extends React.Component {
    static propTypes = {
		campID: PropTypes.number.isRequired,
		users: PropTypes.object,
	};

    state = {
        searched: false,
        searchedUsers: {
            pending: [],
            current: [],
            removed: []
        }
    };

    approveUser = (userID) => {
		this.props.approveUser(this.props.campID, userID)
	};

    rejectUser = (userID) => {
		this.props.rejectUser(this.props.campID, userID)
	};

    removeUser = (userID) => {
		this.props.removeUser(this.props.campID, userID)
	};

    searchUsers = (e) => {

		e.preventDefault();

		var searched = false,
			searchVal = e.target.value,
			originalUsers = this.props.users,
			searchedUsers = {},
			re = new RegExp(searchVal,"gi");

		for (var i = 0; i < Object.keys(originalUsers).length; i++) {

			var status = Object.keys(originalUsers)[i];

			searchedUsers[status] = originalUsers[status].filter(function(user) {
				return (
					!!re.exec(user.first) ||
					!!re.exec(user.last) ||
					!!re.exec(user.bio)
				)
			})

			searched = true;

		}

		this.setState({
			searched: searched,
			searchedUsers: searchedUsers
		})

	};

    userRows = (users) => {
		var rows = [];
		for( var status in users ) {
			if( users[status].length < 1 ) continue;
			rows.push( this.userRow( status, users[status] ) )
		}
		if( rows.length < 1 ) rows.push(<p className="text-center mtop50">No users to approve, reject or remove</p>)
		return rows;
	};

    userRow = (status, users) => {
		return <div className="panel mbot20">
			<h4 className="m10">{ (status == 'removed' ? 'Removed & Rejected' : status).toUpperCase() + ' USERS' }</h4>
			<hr />
			<div className="row">
				{ users.map( (user, i) => {
					let item = [<div className="col-sm-3 ptop15 pbot15 text-center narrow-gutter" key={user.ID}>
						<div className="row">
							<div className="col-xs-8 col-xs-offset-2">
								<Link to={user.link}>
					        		<div className="profile-image" style={{backgroundImage: 'url(' + user.profile_picture + ')'}}></div>
					    		</Link>
				    		</div>
			    		</div>
			    		<p className="lead mtop10">{user.first + ' ' + user.last}</p>
			    		<p className="mbot10">{user.bio}</p>
			    		{ status == 'pending' &&
				    		<p className="lead">
				    			<Icon icon={'accept'} className={'text-mid-success clickable mright10'} onClick={this.approveUser.bind(this, user.ID)} />
				    			<Icon icon={'reject'} className={'text-mid-danger clickable'} onClick={this.rejectUser.bind(this, user.ID)} />
				    		</p>
				    	}
			    		{ status == 'current' &&
				    		<p className="lead">
				    			<Icon icon={'remove'} className={'text-mid-danger clickable mright10'} onClick={this.removeUser.bind(this, user.ID)} />
				    		</p>
				    	}
					</div>]
					if( (i + 1) % 4 === 0 ) item.push(<div className="clearfix" key={'clear-'+i}></div>)
					if( 'first' in user ) return item;
				}) }
			</div>
		</div>
	};

    render() {

		var users = this.state.searched ? this.state.searchedUsers : this.props.users;

		return (

			<div>
				<div className="mbot20">
					<div className="row">
						<div className="col-sm-6 col-sm-offset-3 form-group">
							<input className="form-control" onChange={this.searchUsers} placeholder="Search users..." />
						</div>
					</div>
				</div>
				{ this.userRows(users) }
			</div>

		)

	}
}

const mapDispatchToProps = dispatch => bindActionCreators({ approveUser, rejectUser, removeUser }, dispatch);

export default connect(
    null,
    mapDispatchToProps
)( Users );





// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/DashboardFeed-Users.jsx